import { render, staticRenderFns } from "./CheckItemCard2.vue?vue&type=template&id=06a00cf6&scoped=true&"
import script from "./CheckItemCard2.vue?vue&type=script&lang=js&"
export * from "./CheckItemCard2.vue?vue&type=script&lang=js&"
import style0 from "./CheckItemCard2.vue?vue&type=style&index=0&id=06a00cf6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a00cf6",
  null
  
)

export default component.exports